var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitemap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_(186) 1",
    clipPath: "url(#clip0_8369_15748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0146 26.1217V18.187H25.0145V26.1217H37.1694L37.6173 26.6118L43.8487 33.4302H39.7936L35.8567 29.1224H25.0145V33.4302H22.0146V29.1224H12.4082L8.60702 33.4302H4.61328L11.0624 26.1217H22.0146Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M6.27396 32.6812L6.27497 32.6801H8.26818L8.26711 32.6812H9.53781C10.5504 32.6812 11.4704 33.095 12.1368 33.7618C12.8033 34.4284 13.2171 35.3487 13.2171 36.3615V42.2217C13.2171 43.2346 12.8033 44.1548 12.1368 44.8214C11.4704 45.488 10.5504 45.9019 9.53781 45.9019H3.6793C2.66673 45.9019 1.74668 45.488 1.08022 44.8214C0.413716 44.1548 0 43.2346 0 42.2217V36.3615C0 35.3487 0.413716 34.4284 1.08022 33.7618C1.74663 33.0952 2.66668 32.6812 3.6793 32.6812H6.27396Z",
    fill: "#DC9FD2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M42.1467 32.6801L42.1479 32.6812H44.321C45.3336 32.6812 46.2536 33.0952 46.9202 33.7618C47.5866 34.4284 48.0003 35.3487 48.0003 36.3615V42.2217C48.0003 43.2346 47.5866 44.1548 46.9202 44.8214C46.2536 45.488 45.3336 45.9019 44.321 45.9019H38.4625C37.45 45.9019 36.5298 45.488 35.8634 44.8214C35.1969 44.1548 34.7832 43.2346 34.7832 42.2217V36.3615C34.7832 35.3477 35.1973 34.4282 35.8632 33.7623C36.5302 33.0949 37.4512 32.6812 38.4625 32.6812H40.125L40.1238 32.6801H42.1467Z",
    fill: "#97D3C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M24.2632 32.6801V32.6812H26.5358C27.5484 32.6812 28.4684 33.0952 29.1348 33.7618C29.8013 34.4284 30.215 35.3487 30.215 36.3615V42.2217C30.215 43.2346 29.8013 44.1548 29.1348 44.8214C28.4684 45.488 27.5484 45.9019 26.5358 45.9019H20.6773C19.6647 45.9019 18.7447 45.488 18.0783 44.8214C17.4117 44.1548 16.998 43.2346 16.998 42.2217V36.3615C16.998 35.3487 17.4117 34.4284 18.0783 33.7618C18.7447 33.0952 19.6647 32.6812 20.6773 32.6812H22.7632V32.6801H24.2632Z",
    fill: "#DA9898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4241 3.69936C43.4241 2.68645 43.0104 1.76615 42.344 1.09956C41.6775 0.432975 40.7574 0.0190568 39.7449 0.0190568H8.25538C7.24285 0.0190568 6.3228 0.432975 5.6563 1.09956C4.9899 1.76615 4.57617 2.68645 4.57617 3.69936V15.2364C4.57617 16.2493 4.9899 17.1695 5.6563 17.8362C6.3228 18.5028 7.24285 18.9167 8.25538 18.9167H22.0142H22.764V18.9373H24.264V18.9167H25.014H39.7449C40.7574 18.9167 41.6775 18.5028 42.344 17.8362C43.0104 17.1695 43.4241 16.2493 43.4241 15.2364V3.69936Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6321 4.31862H11.3672V5.81903H36.6321V4.31862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6321 7.06545H11.3672V8.56586H36.6321V7.06545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6321 9.81226H11.3672V11.3128H36.6321V9.81226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6321 12.5593H11.3672V14.0597H36.6321V12.5593Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8369_15748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 45.8824,
    fill: "white",
    transform: "translate(0 0.0195923)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemap);
export default __webpack_public_path__ + "static/media/sitemap.3881c6d80f452c6f5765ec290508a7a9.svg";
export { ForwardRef as ReactComponent };